
import Vue from "vue"

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    width: {
      type: String,
      default: "33rem",
    },

    closeOnClickModal: {
      type: Boolean,
      default: true,
    },

    closeOnPressEscape: {
      type: Boolean,
      default: true,
    },

    showClose: {
      type: Boolean,
      default: false,
    },

    scrollable: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    isOpen: {
      get (): boolean {
        return this.value
      },

      set (isOpen: boolean) {
        this.$emit("input", isOpen)
      },
    },
  },

  watch: {
    isOpen (isOpen) {
      if (!isOpen) this.$emit("close")
    },
  },
})
